/* global $:false */

import { strFromU8, unzlibSync } from 'fflate'
import htmx from 'htmx.org/dist/htmx.js'
import PusherClient from 'src/shared/pusher_client.js'

export default class HtmlPush {
  static init (channelPrefix) {
    if (!this.instance) { this.instance = new HtmlPush(channelPrefix) }
    this.instance.setupSubscriptions()
  }

  constructor (channelPrefix) {
    this.pusher = PusherClient.connection()
    this.channelPrefix = channelPrefix
    this.currentSubscriptions = []
  }

  setupSubscriptions () {
    const subscriptions = this._findSubscriptions()
    const newSubscriptions = $(subscriptions).not($(this.currentSubscriptions)).get()
    const oldSubscriptions = $(this.currentSubscriptions).not($(subscriptions)).get()
    $.map(newSubscriptions, (channelName) => this.subscribeToChannel(channelName))
    $.map(oldSubscriptions, (channelName) => this.unsubscribeFromChannel(channelName))
  }

  _findSubscriptions () {
    return $.map($('[data-html-push-subscribe]'), (el) => {
      const channelName = $(el).data('html-push-subscribe')
      return channelName
    })
  }

  subscribeToChannel (channelName) {
    const channel = this.pusher.subscribe(this.channelPrefix + channelName)
    this.currentSubscriptions.push(channelName)

    return channel.bind('message', data => this.handleMessage(data))
  }

  unsubscribeFromChannel (channelName) {
    this.pusher.unsubscribe(this.channelPrefix + channelName)
    this.currentSubscriptions = $(this.currentSubscriptions).not([channelName]).get()
  }

  handleMessage (data) {
    const payload = $(this.decompress(data))
    $.map($(payload), (directive) => {
      const target = $(directive).attr('target')
      const metadata = JSON.parse($(directive).attr('metadata'))
      const content = directive.innerHTML
      $.map($(target), (el) => {
        const shouldContinue = htmx.trigger(target, 'htmlPush:beforeReplace', {
          newContent: content,
          metadata: metadata
        })

        if (!shouldContinue) { return }

        const swapStrategy = $(el).data('push-swap') || 'innerHTML'
        if (swapStrategy === 'outerHTML') {
          this.swapOuterHTML(el, content, metadata)
        } else {
          this.swapInnerHTML(el, content, metadata)
        }
      })
    })
  }

  swapInnerHTML (target, content, metadata) {
    const originalContent = target.innerHTML
    $(target).html(content)

    htmx.process(target)
    htmx.trigger(target, 'htmlPush:afterReplace', {
      originalContent: originalContent,
      newContent: content,
      metadata: metadata
    })
  }

  swapOuterHTML (target, content, metadata) {
    const originalContent = target.outerHTML

    const previousSibling = target.previousSibling
    const parent = target.parentElement

    $(target).replaceWith(content)

    const newTarget = (previousSibling ? previousSibling.nextSibling : parent.firstChild)

    htmx.process(newTarget)
    htmx.trigger(newTarget, 'htmlPush:afterReplace', {
      originalContent: originalContent,
      newContent: content,
      metadata: metadata
    })
  }

  decompress (data) {
    return strFromU8(
      unzlibSync(
        this.base64decode(data)
      )
    )
  }

  base64decode (data) {
    const string = window.atob(data)
    const byteNumbers = new Array(string.length)
    for (let i = 0; i < string.length; i++) {
      byteNumbers[i] = string.charCodeAt(i)
    }
    return new Uint8Array(byteNumbers)
  }
}
